import { render } from "./PCPartidasActivasYRecientesLinea.vue?vue&type=template&id=aab053c6"
import script from "./PCPartidasActivasYRecientesLinea.vue?vue&type=script&lang=js"
export * from "./PCPartidasActivasYRecientesLinea.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__